import React, { useEffect } from "react";
import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import Textarea from "@peracto/peracto-editor-ui/dist/Textarea";

import File from "@peracto/peracto-editor-ui/dist/File";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";

const VideoCarouselForm = ({
    onChange,
    state: { videos, heading = "Videos", selectedCardIndex },
}) => {
    const DEFAULT_CARD = {
        url: "",
        thumbnail: "",
        title: "Video Title",
        description: "Description",
    };

    useEffect(() => {
        return () => {
            onChange({ selectedCardIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <TextInput
                label="Heading"
                onChange={(e) => {
                    onChange({ heading: e.target.value });
                }}
                value={heading}
            />
            {videos?.length === 0 && (
                <>
                    <p>Click 'Add Video' to get started</p>
                    <hr />
                </>
            )}
            {selectedCardIndex !== null &&
                videos &&
                videos[selectedCardIndex] && (
                    <>
                        <File
                            label="Video URL"
                            value={videos[selectedCardIndex].url}
                            onChange={(value) => {
                                const videosClone = [...videos];
                                videosClone[selectedCardIndex].url = value;

                                onChange({
                                    videos: videosClone,
                                });
                            }}
                            isInline={false}
                        />

                        <File
                            label="Thumbnail URL"
                            value={videos[selectedCardIndex].thumbnail}
                            onChange={(value) => {
                                const videosClone = [...videos];
                                videosClone[selectedCardIndex].thumbnail =
                                    value;

                                onChange({
                                    videos: videosClone,
                                });
                            }}
                            isInline={false}
                        />
                        <TextInput
                            label="Title"
                            onChange={(e) => {
                                const videosClone = [...videos];
                                videosClone[selectedCardIndex].title =
                                    e.target.value;

                                onChange({
                                    videos: videosClone,
                                });
                            }}
                            value={videos[selectedCardIndex].title}
                        />

                        <Textarea
                            label="Description"
                            onChange={(e, editor) => {
                                const videosClone = [...videos];
                                videosClone[selectedCardIndex].description =
                                    editor.getData();

                                onChange({
                                    videos: videosClone,
                                });
                            }}
                            value={videos[selectedCardIndex].description}
                        />

                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={(e) => {
                                const videosClone = [...videos];

                                videosClone.splice(selectedCardIndex, 1);

                                onChange({
                                    videos: videosClone,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                            Remove Video
                        </button>
                    </>
                )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const videosClone = [...videos, DEFAULT_CARD];
                    onChange({
                        videos: videosClone,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Video
            </button>
        </>
    );
};

export default VideoCarouselForm;
